import BaseModal from 'ext-ui/components/BaseModal/BaseModal'
import Button from 'ext-ui/components/Button/Button'
import React, { ReactElement } from 'react'
import SecuritySuccessImage from 'src/assets/images/SecuritySuccess.svg'
import { useTranslate } from 'src/localization/Trns'

import style from './ScreeningSuccessModal.style'

interface ScreeningSuccessModalProps {
  onClick: () => void
  appName: string
}

export default function ScreeningSuccessModal(
  props: ScreeningSuccessModalProps,
): ReactElement {
  const { onClick, appName } = props
  const translate = useTranslate()

  return (
    <BaseModal
      className="ScreeningSuccessModal"
      variant="popup"
      isOpen
      onClose={onClick}
      showCloseButton={false}
      css={style}
      aria-label={translate('Screening Success')}
    >
      <div
        className="screening-success-content"
        data-testid="screening-success-modal"
      >
        <img
          className="success-image"
          src={SecuritySuccessImage}
          alt=""
          role="presentation"
        />
        <h2 className="success-title">{translate('Thank you!')}</h2>
        <p className="success-message">
          {translate('Thanks for helping us keep you and ${appName} secure.', {
            appName,
          })}
        </p>
        <Button data-testid="screening-success-continue-btn" onClick={onClick}>
          {translate('Continue to Virtual Card')}
        </Button>
      </div>
    </BaseModal>
  )
}
